var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box ticket-status-comment"},[_c('h4',{staticClass:"label group-heading"},[_vm._v(" Reason for "+_vm._s(_vm.selectedTicket.ticket.current_status === 'rejected' ? 'rejection' : 'cancellation')+" ")]),_c('p',[_vm._v(_vm._s(_vm.selectedTicketStatusData.comment || 'Missing comment'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }